<!--
 * @Author: likk
 * @Date: 2023-09-05 17:52:35
 * @LastEditTime: 2024-04-17 10:18:13
 * @LastEditors: zhaowh zhaowh@example.com
 * @Description: 
-->
<template>
  <el-main class="business-area">
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <div class="top-tit">
        作业需求信息
        <!-- <span class="back" @click="$router.back(-1)"><img src="@/assets/gx/icon_back.png" />返回</span> -->
      </div>
      <div class="content">
        <div class="plate-status">
          <div class="icon">
            <!-- 待审核 -->
            <img v-if="detail.auditStatus==10" src="@/assets/gx/status/icon_daishenhe.png"/>
            <!-- 审核通过 -->
            <img v-if="detail.auditStatus==20" src="@/assets/gx/status/icon_daijiedan.png"/>
            <!-- 不通过 -->
            <img v-if="detail.auditStatus==30" src="@/assets/gx/status/icon_butongguo.png"/>
            <!-- 需求过期 -->
            <img v-if="detail.auditStatus==40" src="@/assets/gx/status/icon_guoqi.png"/>
            <!-- 服务方签约 -->
            <img v-if="detail.auditStatus==41" src="@/assets/gx/status/icon_fwf.png"/>
            <!-- 需求方签约 -->
            <img v-if="detail.auditStatus==42" src="@/assets/gx/status/icon_xqf.png"/>
            <!-- 已找到机手 -->
            <img v-if="detail.auditStatus==50" src="@/assets/gx/status/icon_jishou.png"/>
            <!-- 待验收 -->
            <img v-if="detail.auditStatus==60" src="@/assets/gx/status/icon_daiyanshou.png"/>
            <!-- 已验收 -->
            <img v-if="detail.auditStatus==70" src="@/assets/gx/status/icon_tongguo.png"/>
          </div>
          <div class="info">
            <p class="name">{{detail.auditStatusName}}</p>
            <p class="remark" v-if="detail.auditStatus==30">不通过原因：{{detail.refuseReason}}</p>
          </div>
        </div>
        <div class="map-box" id="mapBox"></div>
        <table class="table-info" width="100%" cellspacing="0">
          <tr>
            <td width="10%" class="title">身份类型</td>
            <td width="18%" class="info">{{ detail.identityTypeName }}</td>
            <td width="10%" class="title">需求方名称</td>
            <td width="18%" class="info">{{ detail.ownerPlainName }}</td>
            <td width="10%" class="title">联系电话</td>
            <td width="18%" class="info">{{ detail.contactPlainPhone }}</td>
          </tr>
          <tr>
            <td width="10%" class="title">紧急程度</td>
            <td width="18%" class="info">{{ detail.requirementTypeName }}</td>
            <td width="10%" class="title">作物类型</td>
            <td width="18%" class="info">{{ detail.cropTypeName}}</td>
            <td width="10%" class="title">作业类型</td>
            <td width="18%" class="info">{{ detail.workTypeName }}</td>
          </tr>
          <tr>
            <td width="10%" class="title">作业面积</td>
            <td width="18%" class="info">{{ detail.workArea }}</td>
            <td width="10%" class="title">作业单价</td>
            <td width="18%" class="info">{{ detail.workPrice }}</td>
            <td width="10%" class="title">作业时间</td>
            <td width="18%" class="info">{{ detail.workDate }}</td>
          </tr>
          <tr>
            <td width="10%" class="title">发布时间</td>
            <td width="18%" class="info">{{ detail.releaseTime }}</td>
            <td width="10%" class="title">作业要求</td>
            <td width="18%" class="info" colspan="3">{{ detail.workAsk }}</td>
          </tr>
        </table>
        <!-- 签约信息 -->
        <div class="qz-box" v-if="detail.auditStatus !== 10 && detail.auditStatus !== 20 && detail.auditStatus !== 30 && detail.auditStatus !== 40">
          <!-- 服务方签字 -->
          <div class="qz-text" style="margin-right:240px;">
              <div class="tit-left-bor">服务方签字</div>
              <div class="qz-pic">
                <el-image 
                  v-if="detail.workServerESign"
                  style="max-width:240px;max-height: 135px;object-fit: contain;"
                  :src="detail.workServerESign" 
                  :preview-src-list="[detail.workServerESign]">
                </el-image>
                <img v-else src="@/assets/gx/status/qianzifw_img.png" alt="" style="max-width:240px;">
              </div>
          </div>
          <!-- 需求方签字 -->
          <div class="qz-text" style="margin-right:240px;">
              <div class="tit-left-bor">需求方签字</div>
              <div class="qz-pic">
                  <el-image 
                      v-if="detail.workDemandESign"
                      style="max-width:240px;max-height: 135px;object-fit: contain;"
                      :src="detail.workDemandESign" 
                      :preview-src-list="[detail.workDemandESign]">
                  </el-image>
                  <img v-else src="@/assets/gx/status/qianzixq_img.png" alt="" style="max-width:240px;">
              </div>
          </div>
        </div>
        <!-- 服务方签约 || 需求方签约 || 待作业 || 待验收 || 已验收 -->
        <template v-if="detail.auditStatus==41 || detail.auditStatus==42 || detail.auditStatus==50 || detail.auditStatus==60 || detail.auditStatus==70">
          <div class="tit-left-bor">作业信息</div>
          <p class="txt-info">
            <span>作业机手：{{workServerInfo.ownerPlainName}}</span>
            <span>联系电话：{{workServerInfo.contactPlainPhone}}</span>
            <span v-if="detail.orderWorkArea">作业面积：<i>{{detail.orderWorkArea}}亩</i></span>
            <span v-if="detail.orderWorkFee">作业费用：<i>{{detail.orderWorkFee}}元</i></span>
            <span v-if="detail.orderWorkDate">作业时间：<i>{{detail.orderWorkDate}}</i></span>
            <span v-if="detail.orderCheckDate">验收时间：<i>{{detail.orderCheckDate}}</i></span>
          </p>
          <table class="table-info table-tb" width="100%" cellspacing="0">
            <tr>
              <td width="17%" class="title">农机品目</td>
              <td width="17%" class="title">生产企业</td>
              <td width="17%" class="title">品牌</td>
              <td width="17%" class="title">型号</td>
              <td width="17%" class="title">购机日期</td>
              <td width="20%" class="title">出厂编号</td>
              <td width="20%" class="title">北斗终端编号</td>
              <td width="12%" class="title">照片</td>
            </tr>
            <tr v-for="(item,index) in workServerInfo.machineRefList" :key="index">
              <td width="10%" class="info">{{item.machineName}}</td>
              <td width="10%" class="info">{{item.companyName}}</td>
              <td width="18%" class="info">{{item.brandName}}</td>
              <td width="10%" class="info">{{item.modelName}}</td>
              <td width="18%" class="info">{{item.buyDate}}</td>
              <td width="18%" class="info">{{item.factoryCode}}</td>
              <td width="18%" class="info">{{item.imei}}</td>
              <td width="18%" class="info"><img class="thumb-machine" :src="item.machinePhotos"/></td>
            </tr>
          </table>
        </template>
        <template v-if="fileList && fileList.length">
          <div class="tit-left-bor">支付信息</div>
          <div class="img-list">
            <el-image :src="item.accessUrl" v-for="(item,index) in fileList" :key="index" :preview-src-list="[item.accessUrl]"></el-image>
          </div>
        </template>
      </div>
    </div>
  </el-main>
</template>

<script>
  import TalksMap from "@/utils/initMapTalks.js";
  import * as maptalks from "maptalks";
  import { workXuqiuDetail } from "@/api/gxInfo"
  export default {
    name:"",
    data(){
      return {
        id:'',
        detail:{},
        workServerInfo:{},//服务信息
        fileList:[],
        TalksMapDialog: new TalksMap(),
      }
    },
    created(){
      this.id = this.$route.query.id;
      this.getDetail();
    },
    mounted(){
      this.mapInit();
    },
    methods:{
      /**
       * @Author: likk
       * @description: 地图初始化
       * @param {*}
       * @return {*}
       */  
      mapInit(){
        this.TalksMapDialog.init("mapBox", 16);
      },
      /**
       * @Author: likk
       * @description: 向地图上添加自定义标注
       * @param {Array} markerList [lng,lat,imgUrl]
       * @return {*}
       */      
      addMarkerToMap(markerList){
        this.TalksMapDialog.map.setCenter({x:markerList[0].lng,y:markerList[0].lat});
        this.pic1Marker = new maptalks.VectorLayer("pic1Marker").addTo(
          this.TalksMapDialog.map
        );
        markerList.forEach( item => {
          const marker = new maptalks.Marker(
            [item.lng,item.lat],
            {
              symbol: [
                {
                  markerFile: item.imgUrl,
                  markerWidth: 22,
                  markerHeight: 32,
                  markerOpacity: 1,
                  // info:item.info
                },
              ],
            }
          ).addTo(this.pic1Marker);

          // marker.on("click", (e) => {
            // let info = e.target._symbol[0].info;
            let info = item.info;
            let content='';
            if(info.type=='work'){
              content = `<div style='font-size:14px;color:#323333'>作业位置：${info.address}</div>`
            }else if(info.type=='service'){
              content = `<div style='font-size:14px;color:#323333'>机手位置：${info.address}</div>`
            }
            marker.setInfoWindow({
              single: false,
              content,
            });
            marker.openInfoWindow();
          });
        // })
        
      },
      /**
       * @Author: likk
       * @description: 获取详情数据
       * @param {*}
       * @return {*}
       */ 
      async getDetail(){
        const { data: {result} } = await workXuqiuDetail(this.id);
        let { workServerInfo,fileList,...data} = result;
        this.detail = data;
        this.workServerInfo = workServerInfo || {};
        this.fileList = fileList;
        let markerList = [{
          lng:data.lng,
          lat:data.lat,
          imgUrl:require('@/assets/gx/biaozhu_dingwei.png'),
          info:{
            type:'work',
            address:data.workAddress
          }
        }]
        if(workServerInfo && workServerInfo.lng && workServerInfo.lat){
          markerList.push({
            lng:workServerInfo.lng,
            lat:workServerInfo.lat,
            imgUrl:require('@/assets/gx/biaozhu_dingwei.png'),
            info:{
              type:'service',
              address:data.workAddress
            }
          })
        }
        this.addMarkerToMap(markerList);
      },

    }
  }
</script>

<style lang="scss" scoped>
@import "../../style.scss";
.main{
  .top-tit{
    height: 56px;
    line-height: 56px;
    font-size: 20px;
    color: #018388;
    font-weight: bold;
    border-bottom: 1px solid #EFEFEF;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .back{
      font-size: 16px;
      color: #999999;
      font-weight: normal;
      display: inline-flex;
      align-items: center;
      cursor: pointer;
      img{
        height: 16px;
        margin-right: 3px;
      }
    }
  }
  .content{
    .plate-status{
      display: flex;
      align-items: center;
      margin: 15px 0;
      .icon{
        width: 68px;
        height: 68px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .info{
        margin-left: 15px;
        .name{
          font-size: 20px;
          color: #212121;
        }
        .remark{
          font-size: 16px;
          color: #666666;
          margin-top: 5px;
        }
      }
    }
    .map-box{
      width: 100%;
      height: 400px;
      position: relative;
    }
    table{
      margin-top: 20px;
      &.table-tb{
        tr{
          td{
            text-align: center;
            .thumb-machine{
              width: auto;
              height: 40px;
            }
          }
        }
      }
    }
    .qz-box {
      display: flex;
      .qz-text {
        span {
          font-size: 20px;
          color: #018388;
          font-weight: bold;
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          &:before {
            content: "";
            display: inline-block;
            width: 4px;
            height: 20px;
            background: #018388;
            margin-right: 5px;
            border-radius: 30px;
          }
        }
      }
    }
    
    .tit-left-bor{
      display: flex;
      align-items: center;
      font-size: 20px;
      color: #018388;
      margin: 10px 0;
      &:before{
        content: "";
        display: inline-block;
        width: 6px;
        height: 20px;
        background: #018388;
        border-radius: 3px;
        margin-right: 5px;
      }
    }
    .txt-info{
      font-size: 16px;
      color: #323333;
      line-height: 50px;
      span{
        margin-right: 30px;
        i{
          font-style: normal;
          color: #018388;
        }
      }
    }
    .img-list{
      .el-image{
        width: 120px;
        height: 120px;
        margin-right: 10px;
        margin-bottom: 10px;
      }
    }
  }
}
::v-deep {
  .el-image {
    img {
      max-width: 240px;
      max-height: 135px;
    }
  }
}
</style>
